import * as React from "react"
const IconAddData = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 141}
        height={props.height || 141}
        fill="none"
        viewBox="0 0 141 141"
        {...props}
    >
        <rect width={140} height={140} x={0.5} y={0.5} fill={props.fill || "#F6F6F6"} rx={70} />
        <path
            stroke={props.stroke || "#64646C"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M78.5 34.5v16a4 4 0 0 0 4 4h16m-20-20h-28a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h40a8.001 8.001 0 0 0 8-8v-44m-20-20 20 20m-28 12v24m-12-12h24"
        />
    </svg>
)
export default IconAddData
